module.exports = __webpack_public_path__ + "img/ic_cash.f0a3c844.png";